import { createApp } from "vue";
import { i18n } from "i18n";
import vui from "vui";
import App from "App";

const el = document.getElementById("subcategory");

const app = createApp(App, {
	srvs: JSON.parse(el.dataset.srvs),
	pcatId: el.dataset.pcatId,
	catId: el.dataset.catId,
	ccy: el.dataset.ccy
});

app.use(i18n);
app.use(vui);

app.mount(el);
